<template>
  <b-container fluid class="px-0">
    <div v-if="showoverlay" class="top-spinner">
      <b-spinner style="z-index:9999; width: 3rem; height: 3rem;" label="Please wait..."></b-spinner>
    </div>
    <b-overlay class="overspin" :show="showoverlay" rounded="sm" fixed>
      <b-container fluid="md" class="menu-items">

        <!-- Show selection for phone/counter/table order -->
        <b-modal id="mod-howtaken" size="lg" title="Choose How Taken" hide-footer no-close-on-backdrop no-close-on-esc>
          <div>
            <b-card-group class="ordertype-mod" deck>
              <ChooseCard
                v-for="option of takenoptions"
                v-bind:key="option.id"
                :option="option"
                @emit-card-choice="updateHowTaken">
              </ChooseCard>
            </b-card-group>
          </div>
        </b-modal>

        <!-- Show selection for phone/counter/table order -->
        <b-modal id="mod-ordertype" size="lg" title="Choose Order Type" hide-footer no-close-on-backdrop no-close-on-esc>
          <div>
            <b-card-group class="ordertype-mod" deck>
              <ChooseCard
                v-for="option of altordertypes"
                v-bind:key="option.id"
                :option="option"
                @emit-card-choice="updateOrderType">
              </ChooseCard>
            </b-card-group>
          </div>
        </b-modal>

        <CustomerDetails
          ref="cusdetails"
          :key="custdets.cust_name"
          :ordertype="ordertype"
          :defaultLocation="defaultLocation"
          :custNameAlert="custNameAlert"
          :custdetails="custdets"
          @emit-cust-details="updateCustDetails">
        </CustomerDetails>

        <b-modal id="mod-setappt" title="Choose Date & Time" ok-only footer-class="mod-foot">
          <b-row>
            <b-col class="orderfor-modal">
              <b-form-checkbox v-model="asap" name="asap-check" switch>ASAP?</b-form-checkbox>
            </b-col>
          </b-row>
          <b-row class="my-2"><b-col class="orderfor-modal">--OR--</b-col></b-row>
          <b-row>
            <b-col class="orderfor-modal">
              <b-calendar v-model="selectedMenuDate" :date-disabled-fn="dateDisabled" locale="en-US" @input="updateMenuDate(selectedMenuDate); asap=false;"></b-calendar>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="orderfor-modal">
              <b-form-timepicker
                class="mt-2"
                locale="en"
                :value="defaultLocation.next_time_slot"
                v-model="pickupTime"
                :state="pickupState"
                :minutes-step="this.defaultLocation.timeslot_increment"
                style="width:270px;"
                @shown="asap=false;"
              ></b-form-timepicker>
            </b-col>
          </b-row>
        </b-modal>

        <!-- Order Header Toolbar -->
        <div>
          <b-navbar class="subnav" type="light" variant="light" style="justify-content: center;">
            <b-navbar-nav>
              <b-nav-item><b-button pill variant="dark" @click="$bvModal.show('mod-howtaken')">How: {{ howtaken }}</b-button></b-nav-item>
              <b-nav-item><b-button pill variant="dark" @click="displayOrderTypeModal">Type: {{ ordertype.name }}</b-button></b-nav-item>
              <b-nav-item>
                <b-button pill variant="dark" @click="popCustomerModal()">
                  <span v-if="ordertype.id==4">Table: {{ custdets.tablenum }}</span>
                  <span v-else>Customer: {{ custdets.cust_name }}</span>
                </b-button>
              </b-nav-item>
              <b-nav-item>
                <b-button pill variant="dark" @click="$bvModal.show('mod-setappt')">
                  For: <span v-if="asap">ASAP</span>
                  <span v-else>{{ selectedMenuDate | placeOrderDate }} @ {{ pickupTime | toTwelveHours }}</span>
                </b-button>
              </b-nav-item>
              <b-nav-item>
                <b-dropdown id="userDropDown" :text="'Server: '+currentUserName" variant="dark" class="staff-select">
                  <b-dropdown-item
                    v-for="sm in staffMembers"
                    :key="sm.id"
                    link-class="staff-select-items py-3"
                    @click="currentUser=sm.id; currentUserName=sm.staff_name">
                    {{ sm.staff_name }}
                  </b-dropdown-item>
                </b-dropdown>
                <!-- <b-form-select
                 v-model="currentUser"
                 :options="staffMembers"
                 value-field="id"
                 text-field="staff_name"
                 class="staff-select"
                 >
                </b-form-select> -->
              </b-nav-item>
            </b-navbar-nav>
          </b-navbar>
        </div>

        <b-row class="item-search mb-2">
          <b-col><b-form-input v-model="itemfilter" type="search" placeholder="Search..." @input="filterItems()"></b-form-input></b-col>
        </b-row>

        <div v-if="cat==-1" fluid="md">
          <h4>No items available on selected day</h4>
        </div>
        <div class="item-display" v-else>
          <div class="row col- justify-content-center categorylist">
            <div id="catscroll" class="scroller pb-2">
              <ul class="hs full">
                <Category
                  v-for="category of categories"
                  :cat=cat
                  v-bind:category="category"
                  v-bind:key="category.id"
                  @catemit="changeCategory">
                </Category>
              </ul>
            </div>
          </div>

          <b-pagination v-if="totalitems>itemlimit" v-model="currentPage" :total-rows="totalitems" :per-page="itemlimit" align="center" @input="changePage()"></b-pagination>

          <div>
            <!-- <b-card-group style="display: inline-block;"> -->
            <b-row cols="1" cols-sm="2" cols-md="3">
              <Item
                v-for="item of items"
                v-bind:item="item"
                v-bind:key="item.id"
                :displayImages="true"
                @optionsemit="loadOptionsModal">
              </Item>
            </b-row>
            <!-- </b-card-group> -->
            <b-pagination v-if="totalitems>itemlimit" v-model="currentPage" :total-rows="totalitems" :per-page="itemlimit" align="center" @input="changePage()"></b-pagination>
            <b-row class="py-5"><b-col><b-button variant="dark" @click="clearOrder()">Clear Order</b-button></b-col></b-row>

            <div id="checkout" class="checkout">
              <b-button id="checkout-button" class="my-2" variant="dark" v-b-toggle.sidebar-orderdets>
                Checkout  <b-badge variant="light">{{orderline_total | toCurrency}}</b-badge>
              </b-button>
            </div>
          </div>
        </div>

        <Options
          id="modopt"
          v-if="showoptionsmodal"
          :current_item="current_item"
          :option_select="option_select"
          :edititem="edititem"
          :line_notes="line_notes"
          :overridden_item_price="overridden_item_price"
          @emit-remove-old-item="removeOldItem"
          @emit-close-options-modal="closeOptionsModal"
          @emit-add-order-to-db="addOrderLineToDB"
        ></Options>

        <div>
          <b-sidebar
            id="sidebar-orderdets"
            bg-variant="dark"
            text-variant="light"
            right
            shadow
            backdrop
          >
            <Sidebar
              v-if="location_id!=0"
              :key="neworder"
              :orderlines="orderlines"
              :vendor_id="vendorId"
              :defaultLocation="defaultLocation"
              :orderline_total="orderline_total"
              :selectedMenuDate="selectedMenuDate"
              :order_type="ordertype.id"
              :pickupTime="pickupTime"
              :custdets="custdets"
              :howtaken="howtaken"
              :asap="asap"
              :existOrder="existOrder"
              :currentUser="currentUser"
              @emit-adjust-line="adjustOrderLine"
              @emit-payment-succeeded="showPaySuccessModal"
              @emit-retrieve-pickup-times="retrievePickupTimes"
              @switch-overlay="switchOverlay"
              @emit-cust-name-alert="popCustomerModal"
            ></Sidebar>
          </b-sidebar>
        </div>
      </b-container>
    </b-overlay>

    <b-modal
      id="pay-success"
      title="PAYMENT SUCCESSFUL"
      header-bg-variant="dark"
      header-text-variant="light"
      body-bg-variant="light"
      body-text-variant="dark"
      footer-bg-variant="light"
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      >
      <p class="my-4">{{ modalSuccessMessage }}</p>
      <template v-slot:modal-footer>
        <b-button variant="dark" @click="resetPage()">OK</b-button>
      </template>
    </b-modal>
  </b-container>
</template>

<script>
// @ is an alias to /src
import Category from '@/components/PlaceOrder/Category.vue'
import Item from '@/components/PlaceOrder/Item.vue'
import Sidebar from '@/components/PlaceOrder/Sidebar.vue'
import Options from '@/components/PlaceOrder/Options.vue'
import ChooseCard from '@/components/PlaceOrder/ChooseCard.vue'
import CustomerDetails from '@/components/PlaceOrder/CustomerDetails.vue'

import moment from 'moment-timezone'

export default {
  name: 'PlaceOrder',
  components: {
    Category,
    Item,
    Sidebar,
    Options,
    ChooseCard,
    CustomerDetails
  },
  props: ['vendorId', 'existOrder'],
  data () {
    return {
      // vendor_id: 0,
      location_id: 0,
      cat: 0,
      categories: [],
      defaultLocation: [],
      // productlists: [],
      invaliddays: [],
      validdates: [],
      items: [],
      orderlines: [],
      locations: [],
      vendor: [],
      line_notes: '',
      overridden_item_price: '',
      current_item: [],
      option_select: [],
      currentPage: 1,
      edititem: false,
      olditem: {},
      // hours: [],
      itemlimit: 15,
      totalitems: 0,
      showoptionsmodal: false,
      payment_intent: [],
      showoverlay: true,
      pickupTime: '',
      errors: [],
      selectedMenuDate: moment().format('YYYY-MM-DD'),
      useScheduledProductLists: false,
      orderToday: true,
      todaysDate: moment().format('YYYY-MM-DD'),
      modalSuccessMessage: '',
      howtaken: 'None',
      ordertype: {},
      takenoptions: [
        { id: 1, name: 'Phone', image_path: 'https://storage.googleapis.com/payoo-vendor-images/phone_order.png' },
        { id: 2, name: 'Counter', image_path: 'https://storage.googleapis.com/payoo-vendor-images/counter_order.png' },
        { id: 3, name: 'Table', image_path: 'https://storage.googleapis.com/payoo-vendor-images/table_order.png' }
      ],
      ordertypes: [
        { id: 1, name: 'Delivery', image_path: 'https://storage.googleapis.com/payoo-vendor-images/delivery_order.png' },
        { id: 2, name: 'Pickup', image_path: 'https://storage.googleapis.com/payoo-vendor-images/pickup_order.png' },
        { id: 3, name: 'Counter', image_path: 'https://storage.googleapis.com/payoo-vendor-images/counter_order.png' },
        { id: 4, name: 'Table', image_path: 'https://storage.googleapis.com/payoo-vendor-images/table_order.png' }
      ],
      altordertypes: [],
      timeslotInterval: 0,
      timeslots: [],
      itemfilter: '',
      allitems: [],
      asap: true,
      neworder: true,
      custdets: {},
      currentUser: 0,
      staffMembers: [],
      currentUserName: '',
      custNameAlert: false
    }
  },

  watch: {
    orderline_total: function() {
      // add, then remove checkout button shake class
      let chk = document.getElementById('checkout');
      chk.classList.add('checkshake');
      setTimeout(function () {
        chk.classList.remove('checkshake');
      }, 1000);
    }
  },

  computed: {
    classActive: function() {
      if (this.selectedMenuDate==this.todaysDate) {
        return 'active';
      } else {
        return '';
      }
    },

    pickupState: function() {
      // Check to see if the current pickupTime is in the list of available timeslots
      if (this.timeslots.indexOf(moment(this.selectedMenuDate + 'T'+this.pickupTime).format('YYYY-MM-DD HH:mm:ss')) == -1) {
        return false;
      } else {
        return true;
      }
    },

    itempages: function() {
        return Math.ceil(this.totalitems / this.itemlimit);
    },

    orderline_total: function() {
      var ordersubtotal = 0;
      for (const orderline of this.orderlines) {
        var linetotal = 0;
        linetotal+= orderline.overridden_item_price ? Number(orderline.overridden_item_price) : orderline.std_price;
        // linetotal+=orderline.std_price;
        for (const option of orderline.options) {
          // find how many options been selected and multiple the price by that amount
          var optqty = option.choiceitems.length;
          linetotal+=(option.add_price*optqty);
          for (const choiceitem of option.choiceitems) {
            linetotal+=(choiceitem.add_price*1);
          }
        }
        linetotal*=orderline.qty;
        ordersubtotal+=linetotal;
      }
      // subtract the discount
      // ordersubtotal -= this.discount_total;
      return ordersubtotal;
    },

  },

  methods: {
    switchOverlay(overlay) {
      this.showoverlay=overlay;
    },

    dateDisabled(ymd, date) {
      const weekday = date.getDay()
      return this.invaliddays.includes(weekday) && !this.validdates.includes(ymd);
    },

    async closeOptionsModal() {
      await this.retrieveOrderFromDB();
      this.showoptionsmodal=false;
    },

    removeOldItem() {
      this.edititem=false;
      this.adjustOrderLine(this.olditem, 'remove');
    },

    // showPaySuccessModal(payment_intent, pickup_time, order_type, delivery_time=0, cust_addr) {
    showPaySuccessModal(payment_intent) {
      this.emptyBasket();
      // this.pickupTime = pickup_time;
      this.payment_intent = payment_intent;
      if (this.existOrder) {
        this.modalSuccessMessage="Order "+this.payment_intent.order_number+" has been updated successfully!";
      } else {
        this.modalSuccessMessage="Order "+this.payment_intent.order_number+" has been placed successfully!";
      }
      this.$bvModal.show("pay-success");
    },

    changePage() {
      this.showoverlay = true;
      this.retrieveItems(this.cat);
    },

    changeCategory(category) {
      this.currentPage=1;
      if (category > 0) {
        this.retrieveItems(category);
      } else {
        this.cat=category;
        this.retrieveAZItems();
      }
    },

    updateMenuDate(date) {
      this.selectedMenuDate = date;
      // console.log(this.selectedMenuDate);
      this.retrieveDailyData();
    },

    updateHowTaken(howtaken) {
      switch(howtaken) {
        case 1:
          this.howtaken='Phone';
          this.altordertypes = this.ordertypes.filter(ot=>ot.id!=3 && ot.id!=4);
          if (this.neworder) {
            this.$bvModal.show('mod-ordertype');
          }
          break;
        case 2:
          this.howtaken='Counter';
          this.ordertype = this.ordertypes.filter(ot=>ot.id==3);
          this.ordertype = this.ordertype[0];
          if (this.neworder) {
            // this.$bvModal.show('mod-custinfo');
            this.custdets.cust_name = 'None';
          }
          break;
        case 3:
          this.howtaken='Table';
          this.ordertype = this.ordertypes.filter(ot=>ot.id==4);
          this.ordertype = this.ordertype[0];
          if (this.neworder) {
            this.$bvModal.show('mod-custinfo');
          }
          break;
      }
      this.$bvModal.hide('mod-howtaken');
      },

    updateCustDetails(custdets, phonenum) {
      this.custdets = custdets;
      this.custdets.cust_phone=phonenum;
    },

    async updateOrderType(ordertype) {
      var otobj = [];
      otobj = await this.ordertypes.filter(ot=>ot.id==ordertype);
      this.ordertype = await otobj[0];
      this.$bvModal.hide('mod-ordertype');
      if (ordertype==3) {
        this.howtaken = 'Counter';
      } else if (ordertype==4) {
        this.howtaken = 'Table';
      } else {
        this.howtaken = 'Phone';
      }
      if ([1,2].includes(ordertype) && this.neworder && this.howtaken == 'Phone') {
        // if its a pickup / delivery, pop the customer modal as part of the new order info gathering
        this.popCustomerModal();
        // Set this to prevent loading all the modals if you need to change just one
        this.neworder = false;
      }
    },

    popCustomerModal(setalert=false) {
      this.custNameAlert = setalert ? true : false;
      this.$bvModal.show('mod-custinfo');
      if (this.ordertype.id==1) {
        this.$refs.cusdetails.initMQPlaceSearch();
      }
    },

    async displayOrderTypeModal() {
      this.altordertypes = await this.ordertypes;
      this.$bvModal.show('mod-ordertype');
    },

    filterItems() {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      this.items = this.allitems.filter(i=>i.name.toLowerCase().includes(this.itemfilter.toLowerCase()));
    },

/*
*********************************************************************************************************
AXIOS METHODS
*********************************************************************************************************
*/
    // retrieveProductLists() {
    //   // default is active only
    //   this.$api.get('locations/'+this.location_id+'/productlists')
    //     .then(response => {
    //      // JSON responses are automatically parsed.
    //      this.productlists = response.data.productlists;
    //      // change to match the current day
    //      this.selected_pl = response.data.productlists[0].id;
    //      // this.retrieveCategories(response.data.productlists[0].id);
    //      this.retrieveDailyData();
    //     })
    //     .catch(e => {
    //      this.errors.push(e)
    //      console.log(this.errors)
    //     })
    // },

    retrieveCalendar() {
      // default is active only
      this.$api.get('locations/'+this.location_id+'/calendar')
        .then(response => {
         // JSON responses are automatically parsed.
         this.invaliddays = response.data.invaliddays;
         // move the days around so they are compatible with JS (Start of week is Sunday in JS)
         this.invaliddays = this.invaliddays.map(function(d) {
           return (d==6) ? 0 : d+1
         })
         this.validdates = response.data.validdates;
         // Convert all dates to YYYY-MM-DD
         this.validdates = this.validdates.map(date=>moment.parseZone(date).format('YYYY-MM-DD'))
         this.retrieveDailyData();
        })
        .catch(e => {
         this.errors.push(e)
         console.log(this.errors)
        })
    },

    retrieveDailyData() {
      // fetch hours
      // this.retrieveHours();
      this.retrievePickupTimes();
      this.retrieveCategories();
    },

    retrieveCategories() {
      var dateext = (this.useScheduledProductLists==true) ? '&date='+this.selectedMenuDate : '';
      this.$api.get('locations/'+this.location_id+'/categories?active=True'+dateext)
        .then(response => {
         // JSON responses are automatically parsed.
         this.categories = response.data.categories
         this.categories.splice(0, 0, {
           "id": 0,
           "name": "A-Z",
           "sort_order": 0,
           "active": true
         })
         // if this.cat (current category) has not yet been set, set the category to the first available category found
         // or if this.cat (current selected category) does not exist in the retrieved set of categories
         if (this.cat < 1 || response.data.categories.find(c => c.id == this.cat) == undefined) {
           this.cat = 0;
         }
         this.retrieveAZItems();
        })
        .catch(e => {
         this.errors.push(e)
         console.log(this.errors)
        })
    },

    async retrieveAZItems(namefilter='') {
      var dateext = (this.useScheduledProductLists==true) ? '&date='+this.selectedMenuDate : '';
      // Get the access token from the auth wrapper
      const token = await this.$auth.getTokenSilently();

      // Use Axios to make a call to the API
      const { data } = await this.$api.get('items?page='+this.currentPage+'&limit=999&active=True&onpremonly=True'+dateext+namefilter, {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      });
      try {
        // this.items = await this.formatItems(data.items);
        this.items = await data.items;
        this.allitems = this.items;     // copy into separate attribute for use with filtering
        // this.items.sort((a,b) => a.name - b.name);
        this.totalitems = data.total_items;
        this.itemlimit = 999;
        // Update orderlines from existing order (leave until now so can use item data to populate existing items)
        if (this.existOrder) {
          this.addExistingOrderLines()
        }
        this.showoverlay = false;
      } catch(e) {
        console.log(e);
        this.showoverlay = false;
      }
    },

    retrieveItems(category) {
      this.cat=category;
      var dateext = (this.useScheduledProductLists==true) ? '&date='+this.selectedMenuDate : '';
      this.$api.get('/categories/'+category+'/items?page='+this.currentPage+'&limit='+this.itemlimit+'&active=True&onpremonly=True'+dateext)
      .then(response => {
        // JSON responses are automatically parsed.
        // this.items = this.formatItems(response.data.items)
        this.items = response.data.items
        // this.items.sort((a,b) => a.sort_order - b.sort_order);
        this.showoverlay = false;
        this.totalitems = response.data.total_items;
        // this.itemlimit = 15;
      })
      .catch(e => {
        this.errors.push(e)
        console.log(this.errors)
      })
    },

    // re-format all item options for rendering in the options modal
    formatItem(item) {
      if (item.options.length > 0) {
        // sort the options by id so you always have a consistent result
        // item.options.sort((a,b) => a.id - b.id);
        item.options.sort((a,b) => a.sort_order - b.sort_order); // change to sort by sort order - INIT-252
        for (const option of item.options) {
          // if existing order, rename the options property optionitems for consistency with get item data
          // option['optionitems'] = (option['options']) ? option['options'] : option['optionitems'];
          for (const optitem of option.optionitems) {
            if (optitem.name == null) {
              // update the optionitem name with the item name if it's using an item instead
              optitem.name = optitem.item[0].name;
            }
            // add new text field containing add_price and name (leave blank if no additional price)
            if (optitem.add_price > 0){
              optitem.name_price = optitem.name + ' - $' + String(optitem.add_price);
            } else {
              optitem.name_price = optitem.name;
            }
          }
        }
      }
      return item;

      // for (const item of items) {
      // }
      // return items;
    },

    async retrieveLocations() {
      // this.vendor_id = this.$route.params.vendorId;
      // fetch locations
      return this.$api.get('vendor/'+this.vendorId+'/locations')
      .then(response => {
         // JSON responses are automatically parsed.
         this.locations = response.data.locations;
         this.useScheduledProductLists = response.data.locations[0].use_list_schedules;
         this.location_id = response.data.locations[0].id;
         this.defaultLocation = response.data.locations[0];
         // set vendor
         this.vendor = response.data.locations[0].vendor;
         moment.tz.setDefault(response.data.locations[0].vendor.timezone)
         // Set favicon
         const favicon = document.getElementById("favicon");
         favicon.href = this.vendor.company_logo_url;
         // Set title
         document.title = this.vendor.name;
         if (this.useScheduledProductLists == true) {
           this.selectedMenuDate=this.todaysDate;
         }
      })
      .catch(e => {
       this.errors.push(e)
       console.log(this.errors)
      })
    },

    retrievePickupTimes() {
      // this.$api.get('locations/'+this.location_id+'/pickuptimes?date='+this.todaysdate)
      this.$api.get('locations/'+this.location_id+'/pickuptimes?date='+this.selectedMenuDate)
        .then(response => {

         // JSON responses are automatically parsed.
         this.timeslots = response.data.time_slots
         if (this.pickupTime == '') {
           this.pickupTime = response.data.next_time_slot
         }
         // this.$emit('emit-next-timeslot', response.data.next_time_slot);
        })
        .catch(e => {
         this.errors.push(e)
         console.log(this.errors)
        })
    },

    async retrieveUsers() {
      const token = await this.$auth.getTokenSilently();
      const { data } = await this.$api.get('users', {
        headers: {
          Authorization: `Bearer ${token}`    // send the access token through the 'Authorization' header
        }
      });
      try {
        this.staffMembers = await data.users;
        this.staffMembers.map(u => u.staff_name = u.first_name + ' ' + u.last_name.substring(0,1));
        // for (let idx in this.staffMembers) {
        //   if ('auth0|'+this.staffMembers[idx].user_account_id == this.$auth.user.sub) {
        //     this.currentUser = this.staffMembers[idx].id;
        //     this.currentUserName = this.staffMembers[idx].staff_name;
        //   }
        // }
        // const cu = await this.staffMembers.find(u => u.id==Number(localStorage.user_id));
        const cu = await this.staffMembers.find(u => 'auth0|'+u.user_account_id==this.$auth.user.sub);
        this.currentUser = cu.id;
        this.currentUserName = cu.staff_name;
        this.showoverlay = false;
      } catch(e) {
        console.log(e);
        this.showoverlay = false;
      }
    },


/*
*********************************************************************************************************
END OF AXIOS METHODS
*********************************************************************************************************
*/

    // open up the options selection modal
    async loadOptionsModal(item, edit=true) {
      this.edititem = edit;
      if (this.edititem == false) {
        await this.retrieveItemOptions(item)
        this.option_select = [];
        this.line_notes = '';
        this.overridden_item_price = '';
        // set default options for the current item
        for (let i in this.current_item.options) {
            if (this.current_item.options[i].select_qty==1) {
              this.option_select.push(this.current_item.options[i].optionitems[0].id);
            } else {
              this.option_select.push(undefined);
            }
        }
      }
      this.showoptionsmodal = true;
    },

    async retrieveItemOptions(item) {
      // default is active only
      const { data } = await this.$api.get('items/'+item.id);
      this.current_item=this.formatItem(data.item);
    },

    // make adjustment to the orderitem based on the type of button selected
    adjustOrderLine(orderline, adjusttype) {
      switch (adjusttype) {
        case 'remove':
          // reduce quantity by one unless qty is one, in which case, remove
          if (orderline.qty>1) {
            orderline.qty-=1;
            this.updateOrderInDB(orderline, orderline.qty);
          } else if (orderline.qty===1) {
            this.removeOrderLineFromDB(orderline);
          }
          break;
        case 'add':
          // Update this.line_notes and this.option_select with info from orderline
          this.line_notes = orderline.notes;
          this.overridden_item_price = orderline.overridden_item_price;
          this.option_select = orderline.option_select;
          this.current_item = orderline;
          this.loadOptionsModal(orderline);
          break;
        case 'edit':
          // Update this.line_notes and this.option_select with info from orderline
          this.line_notes = orderline.notes;
          this.overridden_item_price = orderline.overridden_item_price;
          this.option_select = orderline.option_select;
          // set this.edititem to true
          this.edititem = true;
          this.olditem = orderline;
          this.current_item = orderline;
          this.loadOptionsModal(orderline);
          break;
      }
    },



/*
*********************************************************************************************************
INDEXEDDB METHODS
*********************************************************************************************************
*/
    // create data store (on mount)
    createIndexedDB() {
      const request = window.indexedDB.open("basket_db", 3);// Create schema (new version)
      request.onupgradeneeded = event => {
          const db = event.target.result;
          // If object store exists, delete it
          if (db.objectStoreNames.length==1) {
            db.deleteObjectStore("order");
          }
          // then recreate it
          const orderStore = db.createObjectStore(
              "order",
              { keyPath: [ "item_id", "choicestring", "notes" ] }
          );
          // create a compound index for item_id and choicestring - ensures qty only updated for truly identical items
          // arrays not allowed as indexes - https://stackoverflow.com/questions/20899744/how-to-create-index-on-array-element-in-indexeddb
          orderStore.createIndex("ItemIndex", "item_id" );
      };
    },

    emptyBasket() {
      const request = window.indexedDB.open("basket_db");
      request.onsuccess = () => {
        const db = request.result;
        const transaction = db.transaction([ "order" ], "readwrite");
        const orderStore = transaction.objectStore("order");
        orderStore.clear();
        transaction.oncomplete = () => {
          db.close();
        };
      };
    },

    updateOrderInDB(item, newqty) {
      const request = window.indexedDB.open("basket_db");
      request.onsuccess = () => {
        const db = request.result;
        const transaction = db.transaction([ "order" ], "readwrite");
        const orderStore = transaction.objectStore("order");
        orderStore.put({
          item_id: item.item_id,
          name: item.name,
          std_price: Number(item.std_price),
          description: item.description,
          image_path: item.image_path,
          is_giftcard: item.is_giftcard,
          allow_price_override: item.allow_price_override,
          qty: newqty,
          notes: item.notes,
          overridden_item_price: item.overridden_item_price,
          options: item.options,
          choicearray: item.choicearray,
          choicestring: item.choicestring,
          option_select: item.option_select
        });
        transaction.oncomplete = () => {
            db.close();
        };
      };
    },

    buildOptionSelectFromOptions(options) {
      var chcarr = []
      for (const opt of options) {
        if (opt.options.length==1) {
          chcarr.push(opt.options[0].id)
        } else if (opt.options.length>1) {
          var multiarr = []
          Object.values(opt.options).forEach(o =>
            multiarr.push(o.id)
          )
          chcarr.push(multiarr)
        } else if (opt.options.length==0) {
          chcarr.push(null)
        }
      }
      return chcarr;
    },

    addExistingOrder() {
      // Add Order details
      this.custdets.cust_name = this.existOrder.customer.name
      this.custdets.cust_phone = this.existOrder.customer.phone
      this.custdets.cust_email = this.existOrder.customer.email
      this.custdets.cust_addr = this.existOrder.customer.delivery_address
      this.custdets.tablenum = this.existOrder.table_number
      this.ordertype.name = this.existOrder.order_type.name
      this.ordertype.id = this.existOrder.order_type.id
      this.pickupTime = moment.utc(this.existOrder.pickup_time).format('HH:mm:ss')
      this.selectedMenuDate = moment.utc(this.existOrder.pickup_time).format('YYYY-MM-DD')
      this.order_notes = this.existOrder.notes
      this.howtaken = this.existOrder.how_taken
      // Expand to check if pickup time is within an hour (or go the whoile hog and add the asap column to orders)
      if (moment().add(1, 'h').isBefore(this.selectedMenuDate+'T'+this.pickupTime)) {
        this.asap = false;
      }
    },

    addExistingOrderLines() {
      // Add Order Line details
      var lines = []
      for (const obj of this.existOrder.order_lines) {
        var item = this.allitems.filter(i=>i.id==obj.item.id);
        lines.push({
            item_id: item[0].id,
            name: item[0].name,
            description: item[0].description,
            image_path: item[0].image_path,
            is_giftcard: item[0].is_giftcard,
            allow_price_override: item[0].allow_price_override,
            std_price: item[0].std_price,
            qty: obj.quantity,
            notes: obj.notes,
            overridden_item_price: obj.overridden_item_price,
            options: item[0].options,
            option_select: obj.options
        })
      }

      // Add Order Line Options
      for (const l of lines) {
        // Use options to build the option_select property (this generates the selected options in the addOrderLineToDB function)
        // l['option_select'] = this.buildOptionSelectFromOptions(l.options)
        this.option_select = this.buildOptionSelectFromOptions(l.option_select)
        this.addOrderLineToDB(l)
      }
      this.retrieveOrderFromDB();
      // console.log(lines)
    },

    removeErroneousOptionData(options) {
      for (const opt of options) {
        delete opt.date_created;
        delete opt.date_modified;
        delete opt.active;
        for (const oi of opt.optionitems) {
          delete oi.date_created;
          delete oi.date_modified;
          delete oi.active;
          delete oi.item;
        }
      }
      return options;
    },

    // build item structure before adding to db
    buildLineDetails(item, linedets={}) {
      // flatten out the option select array to get an array of selected optionitem ids
      var choicearray = [].concat.apply([], this.option_select);
      // sort them so they can be consistently queried
      choicearray.sort((a, b) => a - b);
      // build into a string of ids to use as a key in the indexedDB (arrays not accepted)
      var choicestring = choicearray.join('');

      var choices = this.removeErroneousOptionData(item.options);
      // build new array to hold selected options only - called choiceitems
      // var choices = item.options;
      for (let i in choices) {
        const chc = choices[i].optionitems.filter(optitem => choicearray.indexOf(optitem.id) >= 0);
        choices[i]['choiceitems'] = chc
      }

      let qty = item.quantity ? item.quantity : 1;
      let item_id = item.id ? item.id : item.item_id;
      let notes = linedets.new_line_notes ? linedets.new_line_notes : item.notes ? item.notes : '' ;
      let overridden_item_price = linedets.new_overridden_item_price ? linedets.new_overridden_item_price : item.overridden_item_price ? item.overridden_item_price : '';
      var linedetails = {
          item_id: item_id,
          name: item.name,
          std_price: Number(item.std_price),
          description: item.description,
          image_path: item.image_path,
          is_giftcard: item.is_giftcard,
          allow_price_override: item.allow_price_override,
          qty: qty,
          notes: notes,
          overridden_item_price: overridden_item_price,
          options: choices,
          choicearray: choicearray,
          choicestring: choicestring,
          option_select: this.option_select
      }
      return linedetails;
    },

    addOrderLineToDB(item, linedets={}) {
      var linedetails = this.buildLineDetails(item, linedets);
      // open db
      const request = window.indexedDB.open("basket_db");
      request.onsuccess = () => {
        const db = request.result;
        const transaction = db.transaction([ "order" ], "readwrite");
        const orderStore = transaction.objectStore("order");

        // read from DB to see if there are any items with same id
        const getRequest = orderStore.get([linedetails.item_id, linedetails.choicestring, linedetails.notes]);
        getRequest.onsuccess = () => {
          // if item exists, update qty
          if (getRequest.result) {
            var newqty = getRequest.result.qty+1;
            // this.updateOrderInDB(linedetails, curr_qty+1);
            orderStore.put({
              item_id: linedetails.item_id,
              name: linedetails.name,
              std_price: Number(linedetails.std_price),
              description: linedetails.description,
              image_path: linedetails.image_path,
              is_giftcard: linedetails.is_giftcard,
              allow_price_override: linedetails.allow_price_override,
              qty: newqty,
              notes: linedetails.notes,
              overridden_item_price: linedetails.overridden_item_price,
              options: linedetails.options,
              choicearray: linedetails.choicearray,
              choicestring: linedetails.choicestring,
              option_select: linedetails.option_select
            });
            // else add the item
          } else {
            // add item
            orderStore.add(linedetails);
          }
          transaction.oncomplete = () => {
            // close db connection
            db.close();
          };
        };
      };
    },

    retrieveOrderFromDB() {
      const request = window.indexedDB.open("basket_db");
      request.onsuccess = () => {
        const db = request.result;
        const transaction = db.transaction([ "order" ], "readwrite");
        const orderStore = transaction.objectStore("order");
        const getRequest = orderStore.getAll();
        getRequest.onsuccess = () => {
          this.orderlines = getRequest.result;
        };
      };
    },

    removeOrderLineFromDB(item) {
      const request = window.indexedDB.open("basket_db");
      request.onsuccess = () => {
        const db = request.result;
        const transaction = db.transaction([ "order" ], "readwrite");
        const orderStore = transaction.objectStore("order");
        // compound key must be specified when deleting
        orderStore.delete([item.item_id, item.choicestring, item.notes]);
        transaction.oncomplete = () => {
          db.close();
        };
        transaction.onerror = function(event) {
          console.log('Transaction not opened due to error: ' + transaction.error + ' / ' + event);
        };
      };
      this.retrieveOrderFromDB();
    },

/*
*********************************************************************************************************
END OF INDEXEDDB METHODS
*********************************************************************************************************
*/

    async clearOrder() {
      this.neworder= await false;
      this.current_item = await [];
      this.custdets = await {};
      this.custdetails = await {};
      this.howtaken = await 'None';
      this.itemfilter = await '';
      this.orderlines = await [];
      this.line_notes = await '';
      this.overridden_item_price = await '';
      this.payment_intent = await [];
      this.selectedMenuDate = await moment().format('YYYY-MM-DD');
      this.pickupTime = await '';
      this.ordertype = await {};
      this.asap = await true;
      this.neworder = await true;
      this.custNameAlert = await false;
      this.customTip = await 0;
      await this.emptyBasket();
      await this.retrievePickupTimes();
      this.$bvModal.show('mod-howtaken');
    },

    resetPage() {
      this.$router.push('/Orders');
      return false;
    },

    async prepareMenuPage() {
      await this.retrieveLocations();
      this.retrieveCalendar();
      this.retrieveUsers();
    }

  // end of methods
  },

  // Fetches posts when the component is created.
  created() {
    // create IndexedDB
    try {
      this.createIndexedDB();
    } catch (error) {
      this.postErrorToLog(error, 4, 'Unable to create IndexedDB', 'No order');
    }
    this.prepareMenuPage();
  },

  mounted() {
    this.emptyBasket()
    if (this.existOrder) {
      this.addExistingOrder()
    }
    this.retrieveOrderFromDB();
    if (this.howtaken=='None') {
      // this.neworder=true;
      this.$bvModal.show('mod-howtaken');
    }
    // REMOVE
    // try {
    //   document.getElementById('catscroll').addEventListener('scroll', this.hideScrollArrows);
    // } catch (error) {
    //   console.error(error);
    // }
  },

  // REMOVE
  // beforeDestroy() {
  //   try {
  //     document.getElementById('catscroll').removeEventListener('scroll', this.hideScrollArrows);
  //   } catch (error) {
  //     console.error(error);
  //   }
  //
  // }

}
</script>

<style>
  @import '../styles/style.css';

</style>
